import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
import dayjs from "dayjs";

const employeeRatingsApi = factory.get("employee_ratings");

const initialState = {
  ratings: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      skip: 0,
      take: 25,
      page: 0,
      // search: "",
      user_id: null,
      month: null,
      department_id: null,
      start_date: null,
      end_date: null,
    },
    filters_dialog: false,
  },

  questions: [
    {
      key: "q1",
      value: "جودة العمل المنجز بدون اخطاء وبصورة متكاملة ودقيقة؟",
    },
    {
      key: "q2",
      value: "اهتمام الموظف بوظيفته وتعاونه مع زملائه وتطبيقه لسياسات الشركة؟",
    },
    { key: "q3", value: "مظهر الموظف بما يتوافق مع بيئة الوظيفة؟" },
    {
      key: "q4",
      value: "كيف تقيم تجربتك في التعامل مع الموظف؟",
      answer: "",
    },
    {
      key: "q5",
      value: "القدرة على اتخاذ القرارات وتسيير عمله دون اشراف دائم ومباشر؟",
    },
    { key: "q6", value: "الالتزام بمواعيد الحضور والانصراف؟" },
    {
      key: "q7",
      value: "المهارات القيادية والاشرافية لمهام مستقبلية؟",
    },

    { key: "q8", value: "درجة الاعتماد عليه/عليها؟" },
    { key: "q9", value: "القيام باعمال ابداعية وابتكارات؟" },
    { key: "q10", value: "الاجتهاد والتجاوب مع ضغط العمل؟" },
    {
      key: "q11",
      value: "تنظيم وترتيب مكان العمل والمحافظة على الاجهزة والمواد؟",
    },
    {
      key: "q12",
      value: "السرعة والكفائة في انجاز الاعمال الموكلة اليه؟",
    },
    {
      key: "q13",
      value: "مساهمة الموظف في إنجاز الأعمال الأخرى خارج القسم",
    },
    {
      key: "q14",
      value: "علاقة الموظف مع زملائه ومقدار تعاونه معهم",
    },
  ],
  answers: [
    { value: 2, label: "ضعيف", color: "error" },
    { value: 4, label: "مقبول", color: "secondary" },
    { value: 6, label: "جيد", color: "warning" },
    { value: 8, label: "جيد جدا", color: "info" },
    { value: 10, label: "ممتاز", color: "success" },
  ],
  employee_ratings: {
    loading: false,
    dialog: false,
    form: {
      id: "",
      user_id: null,
      job_title: "",
      date: null,
      note: "",
      q1: null,
      q2: null,
      q3: null,
      q4: null,
      q5: null,
      q6: null,
      q7: null,
      q8: null,
      q9: null,
      q10: null,
      q11: null,
      q12: null,
      q13: null,
      q14: null,
      average: 0,
    },
  },
};

export const employeeRatings = createSlice({
  name: "employeeRatings",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setDataTable: (state, { payload }) => {
      state.ratings.data = payload.data.data;
      state.ratings.total = payload.data.total;
    },
    setFormDialog: (state, { payload }) => {
      if (payload) {
        state.employee_ratings.form.id = payload.id;
        state.employee_ratings.form.q1 = payload.q1;
        state.employee_ratings.form.q2 = payload.q2;
        state.employee_ratings.form.q3 = payload.q3;
        state.employee_ratings.form.q4 = payload.q4;
        state.employee_ratings.form.q5 = payload.q5;
        state.employee_ratings.form.q6 = payload.q6;
        state.employee_ratings.form.q7 = payload.q7;
        state.employee_ratings.form.q8 = payload.q8;
        state.employee_ratings.form.q9 = payload.q9;
        state.employee_ratings.form.q10 = payload.q10;
        state.employee_ratings.form.q11 = payload.q11;
        state.employee_ratings.form.q12 = payload.q12;
        state.employee_ratings.form.q13 = payload.q13;
        state.employee_ratings.form.q14 = payload.q14;
        state.employee_ratings.form.date = payload.date;
        state.employee_ratings.form.note = payload.note;
        state.employee_ratings.form.job_title = payload.job_title;
        state.employee_ratings.form.average = payload.average || 0;
        state.employee_ratings.form.user_id = {
          id: payload.user_id,
          full_name: payload.user_name,
          department_name: payload.department,
        };
      }

      state.employee_ratings.dialog = !state.employee_ratings.dialog;
    },
    resetForm: (state, action) => {
      state.employee_ratings.form = initialState.employee_ratings.form;
    },
    setFiltersDialog: (state, action) => {
      state.ratings.filters_dialog = !state.ratings.filters_dialog;
    },
    setFilters: (state, { payload }) => {
      state.ratings.filters = {
        ...state.ratings.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.ratings.filters = initialState.ratings.filters;
    },
  },
});

export const {
  setLoading,
  setFormDialog,
  setDataTable,

  resetForm,
  setFilters,
  setFiltersDialog,
  resetFilters,
} = employeeRatings.actions;

export default employeeRatings.reducer;

const getAll = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading("ratings"));
    const filters = getState().employeeRatings.ratings.filters;
    const filters_ = {
      ...filters,
      user_id: filters.user_id?.id || null,
      department_id: filters.department_id?.id || null,
    };
    const res = await employeeRatingsApi.getAll(filters_);
    dispatch(setDataTable(res));
    dispatch(setLoading("ratings"));
  } catch (err) {
    dispatch(setLoading("ratings"));
    throw new Error(err);
  }
};
const create = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("employee_ratings"));
    await employeeRatingsApi.create({
      ...data,
      date: dayjs(data.date).format("YYYY-MM-DD"),
      user_id: data.user_id?.id,
    });
    dispatch(setLoading("employee_ratings"));
    dispatch(
      showNotification({
        message: "تم التقييم بنجاح",
        type: "success",
      })
    );
    dispatch(setFormDialog());
    dispatch(getAll());
  } catch (err) {
    dispatch(setLoading("employee_ratings"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const update = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("employee_ratings"));

    await employeeRatingsApi.update({
      ...data,
      date: dayjs(data.date).format("YYYY-MM-DD"),
      user_id: data.user_id?.id,
    });
    dispatch(setFormDialog());
    dispatch(
      showNotification({
        message: "تم التعديل بنجاح",
        type: "success",
      })
    );
    dispatch(getAll());
    dispatch(setLoading("employee_ratings"));
  } catch (err) {
    dispatch(setLoading("employee_ratings"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const deleteById = (id) => async (dispatch) => {
  try {
    await employeeRatingsApi.delete(id);
    dispatch(
      showNotification({
        message: "تم حذف  التقييم بنجاح",
        type: "success",
      })
    );
    dispatch(getAll());
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const EmployeeRatings = {
  getAll,
  deleteById,
  create,
  update,
};
